import { Icon, getTheme, pxToRem, styled } from '~/modules';
import Button from '../Button';
import Modal from '../Modal';
import Typography from '../Typography';

const textMain = getTheme('text.main');

const spacingSm = getTheme('spacing.sm');
const spacingLg = getTheme('spacing.lg');
const spacingXl = getTheme('spacing.xl');

export const Wrapper = styled(Modal)`
  width: ${pxToRem(500)};
  max-width: 90%;
  flex-direction: column;
  padding: ${spacingXl}px;
  gap: ${spacingSm}px;
`;

export const ModalIcon = styled(Icon)`
  font-size: ${pxToRem(45)};
  color: ${textMain};
  opacity: 0.6;
`;

export const Title = styled(Typography).attrs({ variant: 'lg' })`
  font-weight: 700;
  text-align: center;
`;

export const Description = styled.span`
  opacity: 0.8 !important;
  text-align: center;
  margin-bottom: ${spacingLg}px;
  font-size: ${pxToRem(15)};
`;

export const DescriptionBold = styled.b`
  font-size: ${pxToRem(15)};
`;

export const ButtonOk = styled(Button)``;
